// Ported 1:1 from the Webflow page markup (scraped/). Class names and data-w-id
// attributes must stay intact: webflow.css and the IX2/Lottie runtime key off them.
import CtaSection from "@/components/CtaSection";
import { site } from "@/content/site";

export default function HomePage() {
  return (
    <>
      <section className="section-hero">
        <div style={{ opacity: "0" }} className="content">
          <div className="w-layout-grid grid-hero">
            <div id="w-node-_37b3a8d2-c553-a736-f678-9b56fa1506c8-99fbaaff" className="block-hero">
              <a href="/ventures" className="link-info w-inline-block">
                <div className="text-info">
                  See our ventures
                  <br />
                </div>
                <div className="block-icon-info">
                  <img src="/assets/cdn/655c5d4d25d668c29fb0f1e5_bx-arrow-to-right.svg" loading="eager" alt="" className="icon-info" />
                </div>
              </a>
              <h1 className="heading-hero h1-as-h2">
                <strong>Venture Studio specializing in #AI, #Communities, #Sales &amp; #HR</strong>
              </h1>
              <p className="paragraph-hero">
                We build on our {site.yearsOnMarket} years of expertise in software development to create the next generation of successful AI ventures.
              </p>
              <div className="button-hero">
                <a href="/contact" className="button w-button">Contact us</a>
                <a href="/about-us" className="link-button w-inline-block">
                  <img src="/assets/cdn/655f68f11650db34b176dcf4_Meet%20the%20team.svg" loading="eager" alt="" className="icon-button" />
                  <div className="text-button">About Abilitics</div>
                </a>
              </div>
            </div>
            <div id="w-node-a4cb2e2c-97ad-0ff4-4b5f-cbaa674163ff-99fbaaff" data-w-id="a4cb2e2c-97ad-0ff4-4b5f-cbaa674163ff" className="lottie">
              <div className="lines-a1">
                <div style={{ width: "1px", height: "0%" }} className="line-w" />
                <div style={{ width: "1px", height: "0%" }} className="line-w" />
                <div style={{ width: "1px", height: "0%" }} className="line-w" />
                <div style={{ width: "1px", height: "0%" }} className="line-w" />
                <div style={{ width: "1px", height: "0%" }} className="line-w" />
                <div style={{ width: "1px", height: "0%" }} className="line-w" />
              </div>
              <div className="lines-a2">
                <div style={{ width: "0%", height: "1px" }} className="line-h" />
                <div style={{ width: "0%", height: "1px" }} className="line-h" />
                <div style={{ width: "0%", height: "1px" }} className="line-h" />
                <div style={{ width: "0%", height: "1px" }} className="line-h" />
                <div style={{ width: "0%", height: "1px" }} className="line-h" />
                <div style={{ width: "0%", height: "1px" }} className="line-h" />
              </div>
              <div className="block-lottie">
                <div data-w-id="a6cc22d5-0b7b-07bd-77b0-0db7bfad6ad7" data-is-ix2-target="1" className="lottie-animation-1" data-animation-type="lottie" data-src="/assets/cdn/65606443d6dad1ead032923b_Animation%20A2.json" data-loop="0" data-direction="1" data-autoplay="0" data-renderer="svg" data-default-duration="1.3" data-duration="0" data-loading="eager" />
                <div className="lottie-animation-2" data-w-id="fcacfca9-abb0-89de-3b07-ad3baa5921ad" data-animation-type="lottie" data-src="/assets/cdn/656063f1dae260eeca95e7fb_Animation%20A1.json" data-loop="1" data-direction="1" data-autoplay="1" data-is-ix2-target="0" data-renderer="svg" data-default-duration="17.633333333333333" data-duration="0" data-loading="eager" />
              </div>
              <div className="features-lottie">
                <div data-w-id="dab97f38-52c1-874b-eb57-a86cf28eb073" style={{ WebkitTransform: "translate3d(0, 0, 0) scale3d(0, 0, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", MozTransform: "translate3d(0, 0, 0) scale3d(0, 0, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", msTransform: "translate3d(0, 0, 0) scale3d(0, 0, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", transform: "translate3d(0, 0, 0) scale3d(0, 0, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)" }} className="feature-lottie-block">
                  <div className="text-feature-lottie">AI</div>
                </div>
                <div data-w-id="483b5f12-0aff-5df5-faf6-c944f3513cd5" style={{ WebkitTransform: "translate3d(0, 0, 0) scale3d(0, 0, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", MozTransform: "translate3d(0, 0, 0) scale3d(0, 0, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", msTransform: "translate3d(0, 0, 0) scale3d(0, 0, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", transform: "translate3d(0, 0, 0) scale3d(0, 0, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)" }} className="feature-lottie-block a2">
                  <div className="text-feature-lottie">Communities</div>
                </div>
                <div data-w-id="3766eb39-3b62-18b7-eee6-1d9212a81349" style={{ WebkitTransform: "translate3d(0, 0, 0) scale3d(0, 0, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", MozTransform: "translate3d(0, 0, 0) scale3d(0, 0, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", msTransform: "translate3d(0, 0, 0) scale3d(0, 0, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", transform: "translate3d(0, 0, 0) scale3d(0, 0, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)" }} className="feature-lottie-block a3">
                  <div className="text-feature-lottie">Sales</div>
                </div>
                <div data-w-id="525adc7c-9d48-0785-2434-d49c9a28cc47" style={{ WebkitTransform: "translate3d(0, 0, 0) scale3d(0, 0, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", MozTransform: "translate3d(0, 0, 0) scale3d(0, 0, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", msTransform: "translate3d(0, 0, 0) scale3d(0, 0, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)", transform: "translate3d(0, 0, 0) scale3d(0, 0, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)" }} className="feature-lottie-block a4">
                  <div className="text-feature-lottie">HR</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section">
        <div style={{ opacity: "0" }} className="content">
          <div className="w-layout-grid grid-solutions">
            <div id="w-node-b9884999-5af6-d1ff-eb07-8badfae39427-99fbaaff" className="solutions">
              <img src="/assets/cdn/655f6d0af53c2e7a0f01a4f2_Custom%20Software%20development-01.svg" loading="eager" alt="" className="icon-solution" />
              <h2 className="heading-solution">AI</h2>
              <p className="paragraph-solution">Leveraging AI to help humans build stronger relationships</p>
            </div>
            <div id="w-node-f8cf0b0a-7bff-358b-dba5-0aa0133e001c-99fbaaff" className="solutions">
              <img src="/assets/cdn/655f6c8f63e47b85281882a2_Technology%20Advisory-01.svg" loading="eager" alt="" className="icon-solution" />
              <h2 className="heading-solution">
                <strong>Events &amp; Communities</strong>
              </h2>
              <p className="paragraph-solution">Empowering communities to host better spaces for building relationships</p>
            </div>
            <div id="w-node-a3434d13-0c41-9ad3-e49d-ef8ec3aa6675-99fbaaff" className="solutions">
              <img src="/assets/cdn/655f792573116bba4fb89dff_Product%20Management-01.svg" loading="eager" alt="" className="icon-solution" />
              <h2 className="heading-solution">
                <strong>Sales</strong>
              </h2>
              <p className="paragraph-solution">Helping sales to develop their relationships with their future clients</p>
            </div>
            <div id="w-node-ed2a8ead-6789-73b8-380f-ef99f7042f78-99fbaaff" className="solutions">
              <img src="/assets/cdn/655f6b9474d7d1f8b5fd1515_UX%20Design-01.svg" loading="eager" alt="" className="icon-solution" />
              <h2 className="heading-solution">
                <strong>HR</strong>
              </h2>
              <p className="paragraph-solution">Helping HRs to build trustworthy relationships with candidates</p>
            </div>
          </div>
          <div className="clients">
            <div className="subtitle-clients">
              companies that trust us
              <br />
            </div>
            <div data-w-id="f7529cf8-f157-cd39-9418-00b33fb34139" className="block-clients">
              <div className="gradient-clients" />
              <div className="clients-wrapper">
                <img src="/assets/cdn/655dd19ff90a66e0329a5583_Coca-Cola%20Logo.svg" loading="eager" alt="Coca-Cola logo" className="logo-client" />
                <img src="/assets/cdn/655dd12f9145d1564967e3bf_Coca-Cola%20HBC%20Logo.svg" loading="eager" alt="Coca-Cola HBC logo" className="logo-client" />
                <img src="/assets/cdn/655dd12f310ddf5cdaa94d4a_VIvacom.svg" loading="eager" alt="Vivacom logo" className="logo-client a" />
                <img src="/assets/cdn/655dd12fcba4504e5cc41360_wwf-logo.svg" loading="eager" alt="WWF logo" className="logo-client" />
                <img src="/assets/cdn/655e0f8b7de9df5d977610b6_Postbank.svg" loading="eager" alt="Postbank logo" className="logo-client" />
                <img src="/assets/cdn/655dd12f55028878d4232bf1_BNP%20paribas.svg" loading="eager" alt="BNP Paribas logo" className="logo-client" />
                <img src="/assets/cdn/655dd12ff90a66e0329a0d85_lvmh.svg" loading="eager" alt="LVMH logo" className="logo-client a" />
                <img src="/assets/cdn/655dd12fd83d9d9e3b591bd4_City%20of%20Gothenburg%20.svg" loading="eager" alt="City of Gothenburg logo" className="logo-client" />
                <img src="/assets/cdn/655dd12fc012a0ce6b718bbc_Rmowa.svg" loading="eager" alt="Rimowa logo" className="logo-client a" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section">
        <div style={{ opacity: "0" }} className="content">
          <div className="w-layout-grid grid">
            <div id="w-node-_462e3ae4-d17a-4ca9-c67e-daf8b068f90e-99fbaaff" data-w-id="462e3ae4-d17a-4ca9-c67e-daf8b068f90e" className="lottie">
              <div className="lines-b1">
                <div style={{ width: "1px", height: "0%" }} className="line-w" />
                <div style={{ width: "1px", height: "0%" }} className="line-w" />
                <div style={{ width: "1px", height: "0%" }} className="line-w" />
                <div style={{ width: "1px", height: "0%" }} className="line-w" />
                <div style={{ width: "1px", height: "0%" }} className="line-w" />
                <div style={{ width: "1px", height: "0%" }} className="line-w" />
              </div>
              <div className="lines-b2">
                <div style={{ width: "0%", height: "1px" }} className="line-h" />
                <div style={{ width: "0%", height: "1px" }} className="line-h" />
                <div style={{ width: "0%", height: "1px" }} className="line-h" />
                <div style={{ width: "0%", height: "1px" }} className="line-h" />
                <div style={{ width: "0%", height: "1px" }} className="line-h" />
                <div style={{ width: "0%", height: "1px" }} className="line-h" />
              </div>
              <div className="block-lottie">
                <div data-w-id="462e3ae4-d17a-4ca9-c67e-daf8b068f91e" data-is-ix2-target="1" className="lottie-animation-1" data-animation-type="lottie" data-src="/assets/cdn/6560a307abb64a6b2f42860a_Animation%20B1.json" data-loop="0" data-direction="1" data-autoplay="0" data-renderer="svg" data-default-duration="1.3" data-duration="0" data-loading="eager" />
                <div className="lottie-animation-2" data-w-id="462e3ae4-d17a-4ca9-c67e-daf8b068f91f" data-animation-type="lottie" data-src="/assets/cdn/6560a36351d6ae8449783981_Animation%20B2.json" data-loop="1" data-direction="1" data-autoplay="1" data-is-ix2-target="0" data-renderer="svg" data-default-duration="15.033333333333333" data-duration="0" data-loading="eager" />
              </div>
            </div>
            <div id="w-node-a033bb4d-fb8b-e335-6cb2-c443ca8c4bc8-99fbaaff" className="block-right">
              <div className="subtitle">
                For Founders
                <br />
              </div>
              <h2 className="heading">We empower visionary founders</h2>
              <div className="w-layout-grid grid-numbers">
                <div id="w-node-_418ca167-2aa7-6102-c555-e760a541672d-99fbaaff" className="numbers">
                  <img src="/assets/cdn/655f6ebb32cc393b2d9985a0_Check-01.svg" loading="eager" alt="" className="icon-numbers" />
                  <h3 className="heading-numbers">6</h3>
                  <div className="text-numbers">Ventures founded</div>
                </div>
                <div id="w-node-_789e64b8-db23-92f3-fc78-b228e61599d1-99fbaaff" className="numbers green">
                  <img src="/assets/cdn/655f6ebb32cc393b2d9985a0_Check-01.svg" loading="eager" alt="" className="icon-numbers" />
                  <h3 className="heading-numbers green">100+</h3>
                  <div className="text-numbers green">Customers served</div>
                </div>
              </div>
              <p className="paragraph">
                Abilitics has a personal approach in conducting business - we try to always deliver more than expected and go the extra mile in customer support.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section id="solutions" className="section">
        <div style={{ opacity: "0" }} className="content">
          <div className="block-heading">
            <div className="subtitle">
              Our Focus
              <br />
            </div>
            <h2 className="heading">
              <strong>Helping people build stronger relationships</strong>
            </h2>
          </div>
          <div className="w-layout-grid grid-features">
            <div id="w-node-_73c7f32a-11c4-52e7-6886-cdc2875e5856-99fbaaff" className="features">
              <div className="block-heading-features">
                <img src="/assets/cdn/655f7683066ecf30e352527c_ChatGPT%20Agents-01.svg" loading="eager" alt="" className="icon-features" />
                <h5 className="heading-features">
                  <strong>For Communities</strong>
                </h5>
              </div>
              <p className="paragraph-features">With Relinkd, we help communities and their members activate the trusted networks they already have</p>
            </div>
            <div id="w-node-_0eca363f-fcbf-20ff-a3f9-4b4bf2a0943e-99fbaaff" className="features">
              <div className="block-heading-features">
                <img src="/assets/cdn/655f7589ce0241158bc8269f_Intranet%20Portals-01.svg" loading="eager" alt="" className="icon-features" />
                <h5 className="heading-features">
                  <strong>At Career Fairs</strong>
                </h5>
              </div>
              <p className="paragraph-features">With VR Express, we help HRs attract attention to their employer brand</p>
            </div>
            <div id="w-node-a64c2106-90fa-a11e-de5a-7f571bc9fce5-99fbaaff" className="features">
              <div className="block-heading-features">
                <img src="/assets/cdn/655f758811a1c4e93873c781_Talent%20Attraction-01.svg" loading="eager" alt="" className="icon-features" />
                <h5 className="heading-features">
                  <strong>For Sales Teams</strong>
                </h5>
              </div>
              <p className="paragraph-features">With Kognify, we help companies build AI Sales Assistant Agents</p>
            </div>
            <div id="w-node-_81b66805-7f46-c6fe-7448-2cfdb89d7797-99fbaaff" className="features">
              <div className="block-heading-features">
                <img src="/assets/cdn/655f7589ddb0243175c7cecc_Performance%20Management-01.svg" loading="eager" alt="" className="icon-features" />
                <h5 className="heading-features">
                  <strong>For Coworking Spaces</strong>
                </h5>
              </div>
              <p className="paragraph-features">With Skillie, we help residents connect better and share work opportunities</p>
            </div>
            <div id="w-node-_4e0c3da6-b2da-b4cc-3c51-1794343837c2-99fbaaff" className="features">
              <div className="block-heading-features">
                <img src="/assets/cdn/655f7588949c426d7bad299c_Marketing%20Solutions-01.svg" loading="eager" alt="" className="icon-features" />
                <h5 className="heading-features">
                  <strong>For GenZ</strong>
                </h5>
              </div>
              <p className="paragraph-features">With Immersica, we help young professionals train and develop their skills with AI</p>
            </div>
            <div id="w-node-_5ab9e50c-66fe-3297-aab0-dd8ca1a56cd6-99fbaaff" className="features">
              <div className="block-heading-features">
                <img src="/assets/cdn/655f760cd58b7fd73b92b1e0_VR%20Virtual%20Office-01.svg" loading="eager" alt="" className="icon-features" />
                <h5 className="heading-features">
                  <strong>For Municipalities</strong>
                </h5>
              </div>
              <p className="paragraph-features">With VibeJobs, we help municipalities aid citizens in finding local work opportunities</p>
            </div>
          </div>
        </div>
      </section>
      <section className="section">
        <div style={{ opacity: "0" }} className="content">
          <div className="w-layout-grid grid">
            <div id="w-node-_70503c9f-9ff9-2e15-e172-d094aff55f9b-99fbaaff" data-w-id="70503c9f-9ff9-2e15-e172-d094aff55f9b" className="block-reviews">
              <div id="w-node-_70503c9f-9ff9-2e15-e172-d094aff55f9c-99fbaaff" className="reviews-wrapper">
                <div className="review-left">
                  <div className="review">
                    <img src="/assets/cdn/66bb4062e6093e6b1737e958_vibeJobsLogo.png" loading="lazy" sizes="(max-width: 479px) 72vw, (max-width: 767px) 37vw, (max-width: 991px) 39vw, 387.0874938964844px" srcSet="/assets/cdn/66bb4062e6093e6b1737e958_vibeJobsLogo-p-500.png 500w, /assets/cdn/66bb4062e6093e6b1737e958_vibeJobsLogo-p-800.png 800w, /assets/cdn/66bb4062e6093e6b1737e958_vibeJobsLogo.png 1000w" alt="VibeJobs logo" className="homepage-projects-thumbnail" />
                    <h5 className="link-heading-post home-project">
                      <strong>Secures funding from Vitosha Ventures and NV3</strong>
                    </h5>
                    <a href="/news/vitosha-ventures-and-nv3-vc-funds-invest-in-vibejobs-a-venture-co-founded-by-abilitics" className="link-block w-inline-block">
                      <div className="text-link">Read More</div>
                      <div className="block-icon-link">
                        <img src="/assets/cdn/6560bf8e427bcd342303074f_arrow-01.svg" loading="lazy" alt="" className="icon-link" />
                      </div>
                    </a>
                  </div>
                  <div className="review">
                    <img src="/assets/cdn/relinkd-logo.svg" loading="lazy" alt="Relinkd logo" className="homepage-projects-thumbnail" />
                    <h5 className="link-heading-post home-project">Relinkd, the Personal Network Activation App – launched</h5>
                    <a href="/news/abilitics-launches-relinkd-the-personal-network-activation-app" className="link-block w-inline-block">
                      <div className="text-link">Read More</div>
                      <div className="block-icon-link">
                        <img src="/assets/cdn/6560bf8e427bcd342303074f_arrow-01.svg" loading="lazy" alt="" className="icon-link" />
                      </div>
                    </a>
                  </div>
                  <div className="review">
                    <img src="/assets/cdn/6566f661b6b4e1c0898a6df8_WWF.svg" loading="lazy" alt="WWF logo" className="homepage-projects-thumbnail" />
                    <h5 className="link-heading-post home-project">Builds a stronger community</h5>
                    <a href="/news/world-wildlife-fund-wwf-launches-community-engagement-platform-with-abilitics" className="link-block w-inline-block">
                      <div className="text-link">Read More</div>
                      <div className="block-icon-link">
                        <img src="/assets/cdn/6560bf8e427bcd342303074f_arrow-01.svg" loading="lazy" alt="" className="icon-link" />
                      </div>
                    </a>
                  </div>
                </div>
                <div className="review-left">
                  <div className="review">
                    <img src="/assets/cdn/66bb4062e6093e6b1737e958_vibeJobsLogo.png" loading="lazy" sizes="(max-width: 479px) 72vw, (max-width: 767px) 37vw, (max-width: 991px) 39vw, 387.0874938964844px" srcSet="/assets/cdn/66bb4062e6093e6b1737e958_vibeJobsLogo-p-500.png 500w, /assets/cdn/66bb4062e6093e6b1737e958_vibeJobsLogo-p-800.png 800w, /assets/cdn/66bb4062e6093e6b1737e958_vibeJobsLogo.png 1000w" alt="VibeJobs logo" className="homepage-projects-thumbnail" />
                    <h5 className="link-heading-post home-project">
                      <strong>Secures funding from Vitosha Ventures and NV3</strong>
                    </h5>
                    <a href="/news/vitosha-ventures-and-nv3-vc-funds-invest-in-vibejobs-a-venture-co-founded-by-abilitics" className="link-block w-inline-block">
                      <div className="text-link">Read More</div>
                      <div className="block-icon-link">
                        <img src="/assets/cdn/6560bf8e427bcd342303074f_arrow-01.svg" loading="lazy" alt="" className="icon-link" />
                      </div>
                    </a>
                  </div>
                  <div className="review">
                    <img src="/assets/cdn/relinkd-logo.svg" loading="lazy" alt="Relinkd logo" className="homepage-projects-thumbnail" />
                    <h5 className="link-heading-post home-project">Relinkd, the Personal Network Activation App – launched</h5>
                    <a href="/news/abilitics-launches-relinkd-the-personal-network-activation-app" className="link-block w-inline-block">
                      <div className="text-link">Read More</div>
                      <div className="block-icon-link">
                        <img src="/assets/cdn/6560bf8e427bcd342303074f_arrow-01.svg" loading="lazy" alt="" className="icon-link" />
                      </div>
                    </a>
                  </div>
                  <div className="review">
                    <img src="/assets/cdn/6566f661b6b4e1c0898a6df8_WWF.svg" loading="lazy" alt="WWF logo" className="homepage-projects-thumbnail" />
                    <h5 className="link-heading-post home-project">Builds a stronger community</h5>
                    <a href="/news/world-wildlife-fund-wwf-launches-community-engagement-platform-with-abilitics" className="link-block w-inline-block">
                      <div className="text-link">Read More</div>
                      <div className="block-icon-link">
                        <img src="/assets/cdn/6560bf8e427bcd342303074f_arrow-01.svg" loading="lazy" alt="" className="icon-link" />
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div className="reviews-wrapper right">
                <div className="review-right">
                  <div className="review">
                    <img src="/assets/cdn/65fbf73f31cf9a3136515f43_Ministry%20of%20education%20and%20science%20of%20georgia.webp" loading="lazy" sizes="100vw" srcSet="/assets/cdn/65fbf73f31cf9a3136515f43_Ministry%20of%20education%20and%20science%20of%20georgia-p-500.png 500w, /assets/cdn/65fbf73f31cf9a3136515f43_Ministry%20of%20education%20and%20science%20of%20georgia.webp 941w" alt="Ministry of Education and Science of Georgia logo" className="homepage-projects-thumbnail" />
                    <h5 className="link-heading-post home-project">Aid teachers with AI Chatbot</h5>
                    <a href="/news/georgias-ministry-of-education-launches-assistant-chatbot-for-teachers-with-abilitics" className="link-block w-inline-block">
                      <div className="text-link">Read More</div>
                      <div className="block-icon-link">
                        <img src="/assets/cdn/6560bf8e427bcd342303074f_arrow-01.svg" loading="lazy" alt="" className="icon-link" />
                      </div>
                    </a>
                  </div>
                  <div className="review">
                    <img src="/assets/cdn/6566f978518b379a3aa20a03_Postbak.svg" loading="lazy" alt="Postbank logo" className="homepage-projects-thumbnail" />
                    <h5 className="link-heading-post home-project">Launches an HR Hub</h5>
                    <a href="/news/postbank-launches-an-hr-hub-with-abilitics" className="link-block w-inline-block">
                      <div className="text-link">Read More</div>
                      <div className="block-icon-link">
                        <img src="/assets/cdn/6560bf8e427bcd342303074f_arrow-01.svg" loading="lazy" alt="" className="icon-link" />
                      </div>
                    </a>
                  </div>
                  <div className="review">
                    <img src="/assets/cdn/6566f6ec2514b244a441483b_Coca-Cola%20HBC.svg" loading="lazy" alt="Coca-Cola HBC logo" className="homepage-projects-thumbnail" />
                    <h5 className="link-heading-post home-project">Launches a talent marketplace</h5>
                    <a href="/news/coca-cola-hbc-launches-an-opportunity-marketplace-and-mentoring-hub-with-abilitics" className="link-block w-inline-block">
                      <div className="text-link">Read More</div>
                      <div className="block-icon-link">
                        <img src="/assets/cdn/6560bf8e427bcd342303074f_arrow-01.svg" loading="lazy" alt="" className="icon-link" />
                      </div>
                    </a>
                  </div>
                </div>
                <div className="review-right">
                  <div className="review">
                    <img src="/assets/cdn/65fbf73f31cf9a3136515f43_Ministry%20of%20education%20and%20science%20of%20georgia.webp" loading="lazy" sizes="100vw" srcSet="/assets/cdn/65fbf73f31cf9a3136515f43_Ministry%20of%20education%20and%20science%20of%20georgia-p-500.png 500w, /assets/cdn/65fbf73f31cf9a3136515f43_Ministry%20of%20education%20and%20science%20of%20georgia.webp 941w" alt="Ministry of Education and Science of Georgia logo" className="homepage-projects-thumbnail" />
                    <h5 className="link-heading-post home-project">Aid teachers with AI Chatbot</h5>
                    <a href="/news/georgias-ministry-of-education-launches-assistant-chatbot-for-teachers-with-abilitics" className="link-block w-inline-block">
                      <div className="text-link">Read More</div>
                      <div className="block-icon-link">
                        <img src="/assets/cdn/6560bf8e427bcd342303074f_arrow-01.svg" loading="lazy" alt="" className="icon-link" />
                      </div>
                    </a>
                  </div>
                  <div className="review">
                    <img src="/assets/cdn/6566f978518b379a3aa20a03_Postbak.svg" loading="lazy" alt="Postbank logo" className="homepage-projects-thumbnail" />
                    <h5 className="link-heading-post home-project">Launches an HR Hub</h5>
                    <a href="/news/postbank-launches-an-hr-hub-with-abilitics" className="link-block w-inline-block">
                      <div className="text-link">Read More</div>
                      <div className="block-icon-link">
                        <img src="/assets/cdn/6560bf8e427bcd342303074f_arrow-01.svg" loading="lazy" alt="" className="icon-link" />
                      </div>
                    </a>
                  </div>
                  <div className="review">
                    <img src="/assets/cdn/6566f6ec2514b244a441483b_Coca-Cola%20HBC.svg" loading="lazy" alt="Coca-Cola HBC logo" className="homepage-projects-thumbnail" />
                    <h5 className="link-heading-post home-project">Launches a talent marketplace</h5>
                    <a href="/news/coca-cola-hbc-launches-an-opportunity-marketplace-and-mentoring-hub-with-abilitics" className="link-block w-inline-block">
                      <div className="text-link">Read More</div>
                      <div className="block-icon-link">
                        <img src="/assets/cdn/6560bf8e427bcd342303074f_arrow-01.svg" loading="lazy" alt="" className="icon-link" />
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div className="gradient-reviews" />
              <div className="gradient-reviews down" />
              <div className="gradient-reviews" />
            </div>
            <div id="w-node-_70503c9f-9ff9-2e15-e172-d094aff55fa5-99fbaaff" className="block-right">
              <div className="subtitle">
                Blog
                <br />
              </div>
              <h2 className="heading">
                {"Our "}
                <strong>Latest News</strong>
              </h2>
              <p className="paragraph">Learn more about the customers we’ve created value for and the latest news around our ventures.</p>
              <a href="/blog" className="button w-button">Visit our blog</a>
            </div>
          </div>
        </div>
      </section>
      <section id="Team" className="section">
        <div style={{ opacity: "0" }} className="content">
          <div className="block-heading center">
            <div className="subtitle">
              Get in Touch
              <br />
            </div>
            <h2 className="heading large">Leadership Team</h2>
          </div>
          <div className="lottie-wrapper">
            <div className="contact-lottie">
              <div className="contact-lottie-link">
                <div className="block-icon-contact-lottie">
                  <img src="/assets/cdn/655dfd1658ca065efffe0f1f_image.webp" loading="eager" sizes="(max-width: 479px) 27vw, (max-width: 767px) 13vw, (max-width: 1279px) 80px, (max-width: 1439px) 6vw, 80px" srcSet="/assets/cdn/655dfd1658ca065efffe0f1f_image-p-500.webp 500w, /assets/cdn/655dfd1658ca065efffe0f1f_image-p-800.webp 800w, /assets/cdn/655dfd1658ca065efffe0f1f_image-p-1080.webp 1080w, /assets/cdn/655dfd1658ca065efffe0f1f_image-p-1600.webp 1600w, /assets/cdn/655dfd1658ca065efffe0f1f_image.webp 2000w" alt="Rossen Zhivkov" className="icon-contact-lottie team" />
                </div>
                <div className="block-heading-contact-lottie members">
                  <div className="members-heading">
                    <h4 className="heading-contact-lottie memebers">Rossen Zhivkov</h4>
                    <div className="text-contact-lottie members">CEO</div>
                  </div>
                  <div className="members-links">
                    <div className="memebr-link">
                      <a href="mailto:rossen@abilitics.com" className="member-icon w-inline-block">
                        <div className="w-embed">
                          <svg xmlns="http://www.w3.org/2000/svg" width="21.387" height="20" viewBox="0 0 21.387 20">
                            <defs>
                              <style>{".a{fill:currentColor;}"}</style>
                            </defs>
                            <path className="a" d="M113.751,17.109l-9.859-7.114a1.408,1.408,0,0,0-1.646,0l-9.88,7.114h0V28.322a1.407,1.407,0,0,0,1.407,1.407h18.573a1.407,1.407,0,0,0,1.407-1.407V17.109Zm-9.881,7.118a1.408,1.408,0,0,1-1.646,0L92.366,17.11h21.385Z" transform="translate(-92.365 -9.729)" />
                          </svg>
                        </div>
                        <div className="link-description">click to open email</div>
                      </a>
                      <a href="mailto:rossen@abilitics.com" className="text-link">rossen@abilitics.com</a>
                    </div>
                    <div className="memebr-link">
                      <a href="https://www.linkedin.com/in/rossenzhivkov/" target="_blank" className="w-inline-block">
                        <div className="member-icon w-embed">
                          <svg xmlns="http://www.w3.org/2000/svg" width="19.99" height="20" viewBox="0 0 19.99 20">
                            <defs>
                              <style>{".a{fill:currentColor;}"}</style>
                            </defs>
                            <rect className="a" width="4.127" height="13.333" transform="translate(0.396 6.667)" />
                            <path className="a" d="M2.44,0a2.461,2.461,0,0,0,0,4.921h0a2.45,2.45,0,0,0,2.44-2.46v0A2.449,2.449,0,0,0,2.44,0" transform="translate(0)" />
                            <path className="a" d="M15.139,6.26a4.646,4.646,0,0,0-4.018,2.2v-1.8H7.161V19.994h3.96V13c0-1.874.862-2.99,2.515-2.99,1.517,0,2.246,1.072,2.246,2.99v7H19.99V11.558c0-3.57-2.025-5.3-4.851-5.3" transform="translate(0)" />
                          </svg>
                        </div>
                        <div className="link-description">click to open linkedin</div>
                      </a>
                      <a href="https://www.linkedin.com/in/rossenzhivkov/" target="_blank" className="text-link">rossenzhivkov</a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="contact-lottie-link a2">
                <div className="block-icon-contact-lottie">
                  <img src="/assets/cdn/655e0ced940937326c9db779_Jivko%20Petiov%20Circle.png" loading="eager" alt="Jivko Petiov" className="icon-contact-lottie team" />
                </div>
                <div className="block-heading-contact-lottie members">
                  <div className="members-heading">
                    <h4 className="heading-contact-lottie memebers">Jivko Petiov</h4>
                    <div className="text-contact-lottie members">CTO</div>
                  </div>
                  <div className="members-links">
                    <div className="memebr-link">
                      <a href="mailto:jivko@abilitics.com" className="member-icon w-inline-block">
                        <div className="w-embed">
                          <svg xmlns="http://www.w3.org/2000/svg" width="21.387" height="20" viewBox="0 0 21.387 20">
                            <defs>
                              <style>{".a{fill:currentColor;}"}</style>
                            </defs>
                            <path className="a" d="M113.751,17.109l-9.859-7.114a1.408,1.408,0,0,0-1.646,0l-9.88,7.114h0V28.322a1.407,1.407,0,0,0,1.407,1.407h18.573a1.407,1.407,0,0,0,1.407-1.407V17.109Zm-9.881,7.118a1.408,1.408,0,0,1-1.646,0L92.366,17.11h21.385Z" transform="translate(-92.365 -9.729)" />
                          </svg>
                        </div>
                        <div className="link-description">click to open email</div>
                      </a>
                      <a href="mailto:jivko@abilitics.com" className="text-link">jivko@abilitics.com</a>
                    </div>
                    <div className="memebr-link">
                      <a href="https://www.linkedin.com/in/jivkopetiov/" target="_blank" className="w-inline-block">
                        <div className="member-icon w-embed">
                          <svg xmlns="http://www.w3.org/2000/svg" width="19.99" height="20" viewBox="0 0 19.99 20">
                            <defs>
                              <style>{".a{fill:currentColor;}"}</style>
                            </defs>
                            <rect className="a" width="4.127" height="13.333" transform="translate(0.396 6.667)" />
                            <path className="a" d="M2.44,0a2.461,2.461,0,0,0,0,4.921h0a2.45,2.45,0,0,0,2.44-2.46v0A2.449,2.449,0,0,0,2.44,0" transform="translate(0)" />
                            <path className="a" d="M15.139,6.26a4.646,4.646,0,0,0-4.018,2.2v-1.8H7.161V19.994h3.96V13c0-1.874.862-2.99,2.515-2.99,1.517,0,2.246,1.072,2.246,2.99v7H19.99V11.558c0-3.57-2.025-5.3-4.851-5.3" transform="translate(0)" />
                          </svg>
                        </div>
                        <div className="link-description">click to open linkedin</div>
                      </a>
                      <a href="https://www.linkedin.com/in/jivkopetiov/" target="_blank" className="text-link">jivkopetiov</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div data-w-id="c8e67161-3534-32a1-a8f9-cc3286d2d82f" className="lottie">
              <div className="lines-c1">
                <div style={{ width: "1px", height: "0%" }} className="line-w" />
                <div style={{ width: "1px", height: "0%" }} className="line-w" />
                <div style={{ width: "1px", height: "0%" }} className="line-w" />
              </div>
              <div className="lines-c2">
                <div style={{ width: "0%", height: "1px" }} className="line-h" />
                <div style={{ width: "0%", height: "1px" }} className="line-h" />
                <div style={{ width: "0%", height: "1px" }} className="line-h" />
                <div style={{ width: "0%", height: "1px" }} className="line-h" />
                <div style={{ width: "0%", height: "1px" }} className="line-h" />
                <div style={{ width: "0%", height: "1px" }} className="line-h" />
                <div style={{ width: "0%", height: "1px" }} className="line-h" />
                <div style={{ width: "0%", height: "1px" }} className="line-h" />
              </div>
              <div className="block-lottie">
                <div data-w-id="c8e67161-3534-32a1-a8f9-cc3286d2d83f" data-is-ix2-target="1" className="lottie-animation-1" data-animation-type="lottie" data-src="/assets/cdn/6560a307da449238f4d1b55d_Animation%20C1.json" data-loop="0" data-direction="1" data-autoplay="0" data-renderer="svg" data-default-duration="1.3" data-duration="0" data-loading="eager" />
                <div className="lottie-animation-2" data-w-id="c8e67161-3534-32a1-a8f9-cc3286d2d840" data-animation-type="lottie" data-src="/assets/cdn/6560a30751d6ae844977d430_Animation%20C2.json" data-loop="1" data-direction="1" data-autoplay="1" data-is-ix2-target="0" data-renderer="svg" data-default-duration="12" data-duration="0" data-loading="eager" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <CtaSection />
    </>
  );
}
